import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Dashboard: React.FC<IconProps> = ({
                                                fill = COLORS.FG.SOFT,
                                                width = 24,
                                                height = 24,
                                                className,
                                            }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Special / Apiary" width={width} height={height} x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M11.7168 2.05564C11.9285 1.96924 12.1704 1.98339 12.3721 2.0986L16.9971 4.74118C17.2307 4.87467 17.3749 5.12352 17.375 5.39255L17.375 10.2431L21.6221 12.6699C21.8557 12.8034 22 13.0522 22 13.3213L22 18.6074C21.9999 18.8764 21.8557 19.1253 21.6221 19.2588L16.9971 21.9013C16.7666 22.033 16.4834 22.033 16.2529 21.9013L12 19.4707L7.74707 21.9013C7.51656 22.033 7.23344 22.033 7.00293 21.9013L2.37793 19.2588C2.14435 19.1253 2.00012 18.8764 2 18.6074L2 13.3213L2.00684 13.2217C2.03763 12.992 2.17347 12.7867 2.37793 12.6699L6.625 10.2431L6.625 5.39255C6.6251 5.12352 6.76934 4.87467 7.00293 4.74118L11.6279 2.0986L11.7168 2.05564ZM3.5 13.7558L3.5 18.1718L7.375 20.3857L11.25 18.1718L11.25 13.7558L7.375 11.542L3.5 13.7558ZM12.75 13.7558L12.75 18.1718L16.625 20.3857L20.5 18.1718L20.5 13.7558L16.625 11.542L12.75 13.7558ZM8.125 5.82712L8.125 10.2431L12 12.457L15.875 10.2431L15.875 5.82712L12 3.61325L8.125 5.82712Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>

    );
};
